module.exports = __webpack_public_path__ + "static/media/S (204).2f54acc2.jpg";